import { Location } from 'react-router';

import { isSSG } from 'modules/common/utils/isSSG';
import { PATH_CONFIRMATION } from 'domains/userSettings/Routes';

import { getSearchEmailParam } from './hasEmailChangeParam';

export const isEmailChange = (location: Location) => {
  const { pathname = '', search = '' } = location || {};

  const isEmailConfirmationPath = pathname === PATH_CONFIRMATION;

  const hasEmailParam = isSSG() ? false : getSearchEmailParam(search);

  return isEmailConfirmationPath && hasEmailParam;
};
